import { TicketInfo } from '@shared/models/ticket-info';
import { TicketService } from '@routes/ticket-manager/ticket.service';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '@shared/apis';
import { AuthService } from '@core/auth/auth.service';
import { SpinnerService } from '@shared/services/spinner.service';
import { finalize } from 'rxjs/operators';

export class Ticket {

  ticketInfo: TicketInfo = {};

  ticketService: TicketService;

  isAlarm = false;
  isEdit = false;

  active = false;
  status: string;

  ticketChanged$ = new BehaviorSubject<any>(null);
  conversation$ = new BehaviorSubject<any>(null);

  constructor(private apiService: ApiService,
              private authService: AuthService,
              private spinnerService: SpinnerService) {
  }

  load(data, publish = true) {
    this.ticketService = new TicketService(this.authService, this.apiService, this.spinnerService);
    Object.keys(data).forEach(key => {
      this.ticketInfo[key] = data[key];
      this[key] = data[key];
    });

    if (publish) {
      this.selectedTicket(this.ticketInfo);
    } else {
      this.pusher(data);
    }
  }

  pusher(data) {
    Object.keys(data).forEach(key => {
      this.ticketInfo[key] = data[key];
      this[key] = data[key];
    });

    const { logs } = this.ticketInfo || {};
    if (logs && logs.length) {
      this.onEvent(logs);
    }
  }

  selectedTicket(ticketInfo) {
    const { ticketNo, status } = ticketInfo;
    if (status === 'new') {
      return;
    }
    this.spinnerService.start();
    this.apiService.ticket.getTicket(ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.ticketInfo = res;
        const { logs } = this.ticketInfo;
        this.onEvent(logs);
      });
  }

  onEvent(event: any) {
    this.conversation$.next(event);
  }
}
